// Typelizer digest 80752eb3978944089761fd7efa5c62b7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/recurring_invoices/:recurring_invoice_id/runs */
  create: (
    params: { recurringInvoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices/:recurring_invoice_id/runs', params, options),
    method: 'post',
  }),
}
